//stackoverflow.com/a/3410557/14048815
export const getIndicesOf = (searchStr, str) => {
    var searchStrLen = searchStr.length;
    if (searchStrLen === 0) {
        return [];
    }
    var startIndex = 0,
        index,
        indices = [];
    str = str.toLowerCase();
    searchStr = searchStr.toLowerCase();
    while ((index = str.indexOf(searchStr, startIndex)) > -1) {
        indices.push(index);
        startIndex = index + searchStrLen;
    }
    return indices;
};
export const renderFilter = (str, filter) => {
    if (str === undefined || str === null || str === ``) return ``;
    if (filter.length === 0) return str; //no filter
    //sort indices backwards, since we'll be editing string back to front
    let indices = getIndicesOf(filter, str).sort((a, b) => -1 * (a - b));
    if (indices.length === 0) return str; //no matches in string
    let array = [str.substring(indices[0] + filter.length)]; //add end of string
    indices.forEach((loc, i) => {
        array = [
            <u key={i}>{str.substring(loc, loc + filter.length)}</u>,
            ...array,
        ]; //add filtered bit
        if (i === indices.length - 1) {
            array = [str.substring(0, loc), ...array]; //add beginning of string
        } else {
            var afterNextIndex = indices[i + 1] + filter.length;
            array = [
                str.substring(
                    afterNextIndex,
                    afterNextIndex + (loc - afterNextIndex)
                ),
                ...array,
            ]; //add middling parts of string
        }
    });
    return array;
};

export const emptyGuid = '00000000-0000-0000-0000-000000000000';

export const isEmptyGuid = (value) => value && value === emptyGuid;
